import React, { useState } from "react";
import { Gi3dGlasses } from "react-icons/gi";
import { GiAbstract097 } from "react-icons/gi";
import { GiAnchor } from "react-icons/gi";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { FloatingDock } from "../../UI/FloatingDock";
///
import { AnimatePresence, motion } from "motion/react";
import IMG_0812 from "../../../images/IMG_0812.jpeg";
import IMG_0827 from "../../../images/IMG_0827.jpeg";
import { useMediaQuery } from "../../../Constants/useMediaQuery";
const items = [
  {
    title: "მრავალწლიანი გამოცდილება",
    icon: <Gi3dGlasses />,
    content:
      "ვემსახურებით ადგილობრივ ბრენდებსა და ორგანიზაციებს უმაღლესი პასუხისმგებლობით და პროფესიონალიზმით.",
  },
  {
    title: "გარანტირებული ხარისხი",
    icon: <GiAbstract097 />,
    content:
      "ვიყენებთ მხოლოდ პრემიუმ კლასის საღებავებს, რაც უზრუნველყოფს გამძლე, მკვეთრ და ელასტიურ პრინტს.",
  },
  {
    title: "სწრაფი შესრულება",
    icon: <GiAnchor />,
    content:
      "თანამედროვე ტექნიკა საშუალებას გვაძლევს დიდი მოცულობის შეკვეთებიც კი უმოკლეს ვადებში შევასრულოთ.",
  },
  {
    title: "მრავალმხრივი ბეჭდვა",
    icon: <Gi3dGlasses />,
    content:
      "ვბეჭდავთ ნებისმიერი ტიპის ქსოვილზე, ფერებისა და დეტალების შეზღუდვის გარეშე, მაღალი ხარისხის სტანდარტით.",
  },
];
const links = [
  {
    title: "Facebook",
    icon: <FaFacebookF className="h-full w-full text-white" />,
    href: "",
  },

  {
    title: "Instagram",
    icon: <FaInstagram className="h-10 w-20 text-white" />,
    href: "",
  },
];
const LastComp = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const [activeimg, setActiveimg] = useState(items[0].img);

  const toggle = (index, img) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
      setActiveimg(img);
    }
  };
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.99, filter: "blur(20px)" }}
      whileInView={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
      transition={{
        duration: 0.9,
        ease: [0.25, 0.1, 0.25, 1],
      }}
      viewport={{
        once: true,
        amount: 0.3,
      }}
    >
      <div className="w-full bg-gradient-to-b from-[#000000fb] via-[#1d1d1dfb] to-[#000000fb] text-white shadow-2xl py-12 md:py-20 px-2 sfm:px-4 md:px-10 lg:p-10 cxl:p-20">
        <div className="max-w-[1500px] mx-auto flex flex-col lg:flex-row justify-between gap-10 lg:gap-5 h-full">
          <div className="flex  flex-col w-full lg:w-10/12 cxl:w-8/12 p-2 px-2 ssm:px-5 smm:px-8 md:px-12 cxl:px-5 gap-6 md:gap-8">
            <h1 className="text-3xl xsxm:text-4xl cxl:text-5xl font-Mtavruli">
              რატომ ჩვენ?
            </h1>

            <div className="flex flex-col gap-6 md:gap-8">
              <p className="w-full lg:w-[90%] text-sm smm:text-md cxl:text-lg  font-ArialGeo font-semibold leading-7">
                ჩვენ ვაერთიანებთ გამოცდილებას, ხარისხზე ორიენტირებულ მიდგომას და
                თანამედროვე ტექნოლოგიებს. ვიყენებთ პრემიუმ მასალებს, რაც
                უზრუნველყოფს გამძლე და მკვეთრ პრინტს. სწრაფად ვასრულებთ
                შეკვეთებს და ვმუშაობთ ნებისმიერი ტიპის ქსოვილზე მაღალი ხარისხით.
              </p>
              <div className="w-full">
                {items.map((item, index) => {
                  const isOpen = openIndex === index;

                  return (
                    <div
                      key={index}
                      className="border-t border-white first:border-t-0"
                    >
                      <button
                        onClick={() => toggle(index, item.img)}
                        className="w-full flex items-center justify-between px-2 md:px-4 py-2 hover:bg-white hover:text-black transition-all duration-300"
                      >
                        <div className="flex items-center gap-3 md:gap-5 text-xl md:text-2xl">
                          {item.icon}
                          <h1 className="text-sm smm:text-md cxl:text-lg  font-ArialGeo font-semibold">
                            {item.title}
                          </h1>
                        </div>

                        <span
                          className={`transition-transform duration-150 ${
                            isOpen ? "rotate-45" : "rotate-0"
                          }`}
                        >
                          +
                        </span>
                      </button>

                      <div
                        className={`overflow-hidden transition-all duration-200 px-2 md:px-4 ${
                          isOpen ? "max-h-40 py-2" : "max-h-0"
                        }`}
                      >
                        <div className="text-white text-base font-ArialGeo">
                          {item.content}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <p className="w-full lg:w-[90%] border-b-2 pb-3 border-white text-sm smm:text-md cxl:text-lg font-ArialGeo font-semibold leading-7">
                ჩვენ ვახორციელებთ მაღალი მოცულობის კომერციულ ბეჭდვას ხარისხის და
                დეტალების სრული დაცვით. ვემსახურებით კორპორატიულ ღონისძიებებსა
                და ადგილობრივ ბრენდებს, ვუზრუნველყოფთ საიმედოობას და დროულ
                შესრულებას.
              </p>
            </div>

            <div className="w-full">
              <FloatingDock items={links} />
            </div>
          </div>
          <div className="w-full lg:w-6/12 cxl:w-7/12 hidden lg:flex  items-center justify-center">
            <img
              src={IMG_0827}
              alt="active"
              className="w-full max-w-[500px] cxl:max-w-[700px] aspect-square object-cover rounded-md transition-all duration-300"
            />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default LastComp;
